var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.tableData.length ? _c("div", {
    staticClass: "admin-data-authority"
  }, [_vm.tableData.length && _vm.tableData.length > 0 ? _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      columns: _vm.columns,
      "data-source": _vm.tableData,
      bordered: "",
      pagination: false,
      rowKey: "arrId",
      defaultExpandAllRows: true
    }
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0) : _vm._e()], 1) : _c("div", {
    staticClass: "no-data-show"
  }, [_vm._v(" " + _vm._s(_vm.$t("请先完成功能权限配置")) + "   "), _c("svg-icon", {
    attrs: {
      icon: "warn",
      size: 20
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };